import { Env } from 'config/Env'
import { CommunityCapabilityListRequest, GetMyCommunitiesRequest } from 'features/facilities/types'
import { OrganizationStatusRequest } from 'features/organization/types'
import { DropDownEnvelope } from 'utils/types/DropDownEnvelope'
import { Envelope } from 'utils/types/Envelope'

import { HttpClient, ApiRequestTypes } from '../../../utils/apiService/httpService'
import {
  FacilityDetailsFormInput,
  PccFacilityDocumentCategoryListRequest,
  CommunityNoteRequest,
  CommunityContactSaveRequest,
  StaffCategoryCreateRequest,
  StaffCategoryListRequest,
  StaffCategoryUpdateRequest,
  StaffAvailabilitySaveRequest,
  ReferralFacilityListRequest,
  CoverageConfigRequest,
  CommunityDrugPriceSaveRequest,
  ZipSearchResult,
  CountySearchResult,
  GeoSearchResponse,
} from '../types'

const GET_ALL_ORGANIZATIONS_URL = `${Env.REACT_APP_API_URL}Organization/api/Organization/getAll`
const CREATE_FACILITY_URL = `${Env.REACT_APP_API_URL}Organization/api/Facility/create`
const DELETE_FACILITY_URL = `${Env.REACT_APP_API_URL}Organization/api/Facility/delete`
const GET_FACILITY_DETAILS = `${Env.REACT_APP_API_URL}Organization/api/Facility/getdetailById`
const UPDATE_FACILITY_DATA = `${Env.REACT_APP_API_URL}Organization/api/Facility/update`
const GET_FACILITY_LIST = `${Env.REACT_APP_API_URL}Organization/api/Facility/GetFacilityListByOrganizations`
const GET_CATEGORY_LIST = `${Env.REACT_APP_API_URL}Organization/api/FacilityCategory/GetAllCategoryById`

const VIEW_WORDBANK_LIST = `${Env.REACT_APP_API_URL}Organization/api/Wordbank/GetWordBankDetailbyFacilityId`
const MYFACILITYLIST_URL = `${Env.REACT_APP_API_URL}Organization/api/Facility/GetMyFacilityList`

const GET_PCC_FACILITY = `${Env.REACT_APP_API_URL}Organization/api/Pcc/GetPccFacility`
const GET_PCC_FACILITY_DOCUMENT = `${Env.REACT_APP_API_URL}Organization/api/Pcc/GetPccDocumentCategory`
const GET_ORGANIZATIONS_INTEGRATIONS_LIST = `${Env.REACT_APP_API_URL}Organization/api/Organization/OrganizationIntegrationList`

const FACILITY_STATUS_UPDATE_URL = `${Env.REACT_APP_API_URL}Organization/api/Facility/FacilityStatusUpdate`
const GET_COMMUNITY_CAPABILITY_LIST = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/GetCapabilitiesByCommunity`
const UPDATE_COMMUNITY_CAPABILITY_STATUS = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/UpdateCapabilityStatusForCommunity`
const SAVE_NOTE_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityLocationNote/Save`
const GET_NOTE_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityLocationNote/GetByFacilityId`
const GET_REFERRAL_NOTES_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityLocationNote/GetReferralNotes`

const SAVE_CONTACTS_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityContact/Save`
const GET_CONTACTS_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityContact/GetByFacilityId`
const GET_REFERRAL_CONTACTS_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityContact/GetReferralContacts`

const GET_STAFF_CATEGORIES_URL = `${Env.REACT_APP_API_URL}Organization/api/StaffCategory/GetByOrganizationId`
const CREATE_STAFF_CATEGORY_URL = `${Env.REACT_APP_API_URL}Organization/api/StaffCategory/Create`
const UPDATE_STAFF_CATEGORY_URL = `${Env.REACT_APP_API_URL}Organization/api/StaffCategory/Update`
const DELETE_STAFF_CATEGORY_URL = `${Env.REACT_APP_API_URL}Organization/api/StaffCategory/Delete`

const SAVE_STAFF_AVAILABILITY_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityStaffAvailability/Save`
const GET_STAFF_AVAILABILITY_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityStaffAvailability/GetByFacilityId`
const GET_REFERRAL_STAFF_AVAILABILITY_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityStaffAvailability/GetReferralStaffAvailability`

export const getAllOrganizations = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](GET_ALL_ORGANIZATIONS_URL)
export const createFacility = (facilityData: FacilityDetailsFormInput): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_FACILITY_URL, facilityData)
export const getFacilityDetails = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_FACILITY_DETAILS}?id=${id}`)
export const updateFacility = (facilityData: FacilityDetailsFormInput): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](UPDATE_FACILITY_DATA, facilityData)

export const deleteFacility = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${DELETE_FACILITY_URL}?id=${id}`)

export const getFacilityListForDropdown = (orgIds: number[]): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](GET_FACILITY_LIST, orgIds)

const GET_MY_COMMUNITIES = `${Env.REACT_APP_API_URL}Organization/api/Facility/GetMyCommunities`
export const getMyCommunities = (data: GetMyCommunitiesRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_MY_COMMUNITIES, data)

export const getCategoryList = (id: number): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_CATEGORY_LIST}?organizationId=${id}`)

export const viewWordbankList = (facilityId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${VIEW_WORDBANK_LIST}?facilityId=${facilityId}`)

export const getMyFacilityList = (data: Array<number>): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](MYFACILITYLIST_URL, data)

export const getPccFacilityList = (organizationId: number): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_PCC_FACILITY}?organizationId=${organizationId}`)

export const getPccFacilityDocumentList = (
  data: PccFacilityDocumentCategoryListRequest,
): Promise<DropDownEnvelope> => HttpClient[ApiRequestTypes.post](GET_PCC_FACILITY_DOCUMENT, data)

export const getOrganizationsIntegrationsList = (organizationId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_ORGANIZATIONS_INTEGRATIONS_LIST}?organizationId=${organizationId}`,
  )

export const facilityStatusUpdate = (
  facilityStatus: OrganizationStatusRequest,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${FACILITY_STATUS_UPDATE_URL}`, facilityStatus)

export const getCommunityCapabilityList = (
  data: CommunityCapabilityListRequest,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](GET_COMMUNITY_CAPABILITY_LIST, data)

export const updateCommunityCapabilityStatus = (data: {
  capabilityId: number
  communityId: number
  status: number
}): Promise<Envelope> => HttpClient[ApiRequestTypes.put](UPDATE_COMMUNITY_CAPABILITY_STATUS, data)

// ── GeoLocation / Community Configuration API ─────────────────────────────────

// Notes
export const saveNote = (data: CommunityNoteRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_NOTE_URL, data)
export const getNoteByFacilityId = (facilityId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_NOTE_URL}?facilityId=${facilityId}`)
export const getReferralNotes = (data: ReferralFacilityListRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_REFERRAL_NOTES_URL, data)

// Contacts
export const saveContacts = (data: CommunityContactSaveRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_CONTACTS_URL, data)
export const getContactsByFacilityId = (facilityId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_CONTACTS_URL}?facilityId=${facilityId}`)
export const getReferralContacts = (data: ReferralFacilityListRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_REFERRAL_CONTACTS_URL, data)

// Staff Category (org-level CRUD)
export const getStaffCategoriesByOrg = (data: StaffCategoryListRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_STAFF_CATEGORIES_URL, data)
export const createStaffCategory = (data: StaffCategoryCreateRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_STAFF_CATEGORY_URL, data)
export const updateStaffCategory = (data: StaffCategoryUpdateRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](UPDATE_STAFF_CATEGORY_URL, data)
export const deleteStaffCategory = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_STAFF_CATEGORY_URL}?id=${id}`)

// Staff Availability (community-level)
export const saveStaffAvailability = (data: StaffAvailabilitySaveRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_STAFF_AVAILABILITY_URL, data)
export const getStaffAvailabilityByFacilityId = (facilityId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_STAFF_AVAILABILITY_URL}?facilityId=${facilityId}`)
export const getReferralStaffAvailability = (
  data: ReferralFacilityListRequest,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](GET_REFERRAL_STAFF_AVAILABILITY_URL, data)

// ── Coverage Area ──────────────────────────────────────────────────────────────

const BASE_COVERAGE = `${Env.REACT_APP_API_URL}organization/api/FacilityCoverage`
const BASE_GEO_SEARCH = `${Env.REACT_APP_API_URL}organization/api/Geo`

export const getCoverageConfig = (facilityId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${BASE_COVERAGE}/${facilityId}/config`)
export const saveCoverageConfig = (
  facilityId: number,
  data: CoverageConfigRequest,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${BASE_COVERAGE}/${facilityId}/config`, data)

// Community Drug Price
const BASE_COMMUNITY_DRUG_PRICE = `${Env.REACT_APP_API_URL}Organization/api/DrugPriceConfig`

export const createCommunityDrugPrice = (data: CommunityDrugPriceSaveRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](`${BASE_COMMUNITY_DRUG_PRICE}/SaveCommunityDrugPrice?level=2`, data)

export const updateCommunityDrugPrice = (data: CommunityDrugPriceSaveRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](`${BASE_COMMUNITY_DRUG_PRICE}/SaveCommunityDrugPrice?level=2`, data)

export const deleteCommunityDrugPrice = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${BASE_COMMUNITY_DRUG_PRICE}/Delete?id=${id}&level=2`)

export const bulkUploadDrugPrices = (
  organizationId: number,
  facilityId: number,
  file: File,
): Promise<Envelope> => {
  const formData = new FormData()
  formData.append('OrganizationId', String(organizationId))
  formData.append('FacilityId', String(facilityId))
  formData.append('File', file)
  return HttpClient[ApiRequestTypes.post](
    `${BASE_COMMUNITY_DRUG_PRICE}/BulkUploadCommunityDrugPrice`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
}

// Geo search — returns raw arrays (no envelope wrapper)
export const searchZipCodes = (q: string): Promise<GeoSearchResponse<ZipSearchResult>> =>
  HttpClient[ApiRequestTypes.get](`${BASE_GEO_SEARCH}/zip-codes?search=${encodeURIComponent(q)}`)
export const searchCounties = (
  q: string,
  state?: string,
): Promise<GeoSearchResponse<CountySearchResult>> =>
  HttpClient[ApiRequestTypes.get](
    `${BASE_GEO_SEARCH}/counties?search=${encodeURIComponent(q)}${
      state ? `&state=${encodeURIComponent(state)}` : ''
    }`,
  )
